// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalBiPriorAuthorization {
    static getAttributeTypeMap() {
        return MedicalBiPriorAuthorization.attributeTypeMap;
    }
}
MedicalBiPriorAuthorization.discriminator = undefined;
MedicalBiPriorAuthorization.additionalProperties = false;
MedicalBiPriorAuthorization.attributeTypeMap = [
    {
        "name": "approvalNumber",
        "baseName": "approvalNumber",
        "type": "string"
    },
    {
        "name": "approvedQuantity",
        "baseName": "approvedQuantity",
        "type": "string"
    },
    {
        "name": "approvedQuantityUsed",
        "baseName": "approvedQuantityUsed",
        "type": "string"
    },
    {
        "name": "endDate",
        "baseName": "endDate",
        "type": "Date"
    },
    {
        "name": "onFile",
        "baseName": "onFile",
        "type": "boolean"
    },
    {
        "name": "renewalProcessExists",
        "baseName": "renewalProcessExists",
        "type": "boolean"
    },
    {
        "name": "required",
        "baseName": "required",
        "type": "boolean"
    },
    {
        "name": "requiredCodes",
        "baseName": "requiredCodes",
        "type": "string"
    },
    {
        "name": "responsibleOrg",
        "baseName": "responsibleOrg",
        "type": "string"
    },
    {
        "name": "startDate",
        "baseName": "startDate",
        "type": "Date"
    },
    {
        "name": "status",
        "baseName": "status",
        "type": "string"
    },
    {
        "name": "turnaroundTime",
        "baseName": "turnaroundTime",
        "type": "string"
    },
];
//# sourceMappingURL=medicalBiPriorAuthorization.js.map